import React, { useEffect, useState, useRef, useCallback } from "react";
import {gsap} from 'gsap';
import { motion } from "framer-motion";
import Select from "../Select";

// Components
import Modal from "../Modal";

const ModalIA = (props) => {
  const [selection, setSelection] = useState({})
  const [showSelectors, setShowSelectors] = useState(false)
  const [optionsIa, setOptionsIa] = useState({})
  const options = [
    {id: 1, text: "Adattamento dei profili a posizioni specifiche"},
    {id: 2, text: "Individuazione di punti di forza o debolezze frequenti"},
    {id: 3, text: "Raggruppamento in cluster per stile di profilo"},
    {id: 4, text: "Potenziali nascosti. Utenti con punteggi medi, ma molto alti in competenze strategiche poco frequenti"},
    {id: 5, text: "Analisi di un candidato specifico"}
  ];

  const options_1 = {
    "Dirección": [
      "Direttore operativo",
      "Direttore delle risorse umane",
      "Project Manager"
    ],
    "Ventas y Atención": [
      "Responsabile vendite",
      "Rappresentante assistenza clienti",
      "Key Account Manager"
    ],
    "RRHH": [
      "Specialista nella selezione del personale",
      "Formatore / Coach",
      "Consulente HR"
    ],
    "Creativos": [
      "Graphic designer / UX-UI",
      "Specialista marketing digitale",
      "Sviluppatore di prodotti/servizi"
    ],
    "Técnicos": [
      "Ingegnere di processo",
      "Analista dati",
      "Architetto software"
    ],
    "Administrativos": [
      "Assistente di direzione",
      "Coordinatore logistico",
      "Auditor / Controllo qualità"
    ]
  };
  const handleClick = (selected) => {
    console.log("Clic en:", selected);
    setSelection(selected)
    if([2,3,4].includes(selected.id)){
      props.iaSelection(selected)
    } else{
      setShowSelectors(true)
    }
  };

  const sendSelected = () => {
    props.iaSelection(
      {...selection, ...optionsIa }
    )
  }

  console.log(props)
  return (
    <Modal isVisible={true} medium>
      <div>
        <h2 className="o-margin--bottom-size-l">MODAL IA</h2>
      </div>
      {
        showSelectors && 
        <div>
          <p>{selection.title}</p>
          {
            selection.id === 1 &&
            <div style={{width: 400}}>
            <div>
              <Select
                label="Puesto"
                withoutInput
                isRequired
                valueSelected={optionsIa.group}
                options={[
                  {text: "Direzione", value: "Dirección"},
                  {text: "Vendite e Assistenza", value: "Ventas y Atención"},
                  {text: "Risorse Umane", value: "RRHH"},
                  {text: "Creativi", value: "Creativos"},
                  {text: "Tecnici", value: "Técnicos"},
                  {text: "Amministrativi", value: "Administrativos"}
                ]}
                optionClick={(text, value) =>  setOptionsIa({...optionsIa, group: value})}
                style={{ zIndex: 1005 }}
                tick
              />
            </div>
            <div>
              <Select
                label="Posición"
                withoutInput
                isRequired
                valueSelected={optionsIa.position}
                options={options_1[optionsIa.group]?.map((e) => ({
                  text: e,
                  value: e
                })) || []}
                optionClick={(text, value) =>  setOptionsIa({...optionsIa, position: value})}
                style={{ zIndex: 1005 }}
                tick
              />
            </div>
            <div>
              <Select
                label="Numero de candidatos"
                withoutInput
                isRequired
                valueSelected={optionsIa.candidate_number}
                options={
                  [
                    { "text": 1, "value": 1 },
                    { "text": 2, "value": 2 },
                    { "text": 3, "value": 3 },
                    { "text": 4, "value": 4 },
                    { "text": 5, "value": 5 },
                    { "text": 6, "value": 6 },
                    { "text": 7, "value": 7 },
                    { "text": 8, "value": 8 },
                    { "text": 9, "value": 9 },
                    { "text": 10, "value": 10 },
                    { "text": 11, "value": 11 },
                    { "text": 12, "value": 12 },
                    { "text": 13, "value": 13 },
                    { "text": 14, "value": 14 },
                    { "text": 15, "value": 15 },
                    { "text": 16, "value": 16 },
                    { "text": 17, "value": 17 },
                    { "text": 18, "value": 18 },
                    { "text": 19, "value": 19 },
                    { "text": 20, "value": 20 }
                  ]
                }
                optionClick={(text, value) =>  setOptionsIa({...optionsIa, candidate_number: value})}
                style={{ zIndex: 1005 }}
                tick
              />
            </div>
            <div style={{display: 'flex'}}>
            <button
              onClick={() => {
                setSelection({})
                setShowSelectors(false)
              }}

              style={{marginBottom: 10, marginRight: 10}}
              className="c-button c-button--cancel"
            >
              <span className="c-button__text">Cancel</span>
            </button>
            <button
              type="button"
              className="c-button c-modal__button"
              onClick={() => sendSelected()}
            >
              <span className="c-button__text">Go</span>
            </button>

            </div>
            </div>
          }
          {
            selection.id === 5 &&
            <div style={{width: 400}}>
            <div>
              <Select
                label="Candidato"
                withoutInput
                isRequired
                valueSelected={optionsIa.email}
                options={props.users?.map((e) => ({
                  text: e.name !== "" ? e.name : e.email,
                  value: e.email
                })) || []}
                optionClick={(text, value) =>  setOptionsIa({...optionsIa, email: value})}
                style={{ zIndex: 1005 }}
                tick
              />
            </div>
            <div style={{display: 'flex'}}>
            <button
              onClick={() => {
                setSelection({})
                setShowSelectors(false)
              }}

              style={{marginBottom: 10, marginRight: 10}}
              className="c-button c-button--cancel"
            >
              <span className="c-button__text">Cancel</span>
            </button>
            <button
              type="button"
              className="c-button c-modal__button"
              onClick={() => sendSelected()}
            >
              <span className="c-button__text">Go</span>
            </button>

            </div>
            </div>
          }

        </div>
      }
      {
        !showSelectors &&
        <>
          <div className="o-col-container c-modal-info__container">
          <div style={{display: 'flex', flexDirection: 'column'}}>
          {options.map((option, index) => (
            <button
              key={index}
              onClick={() => handleClick(option)}
              style={{marginBottom: 10}}
              // className="c-button c-button--margin-zero"
            >
              <div className="rounded"></div>
              <span>{option.text}</span>
            </button>
          ))} 
          </div>
        </div>
        <button
          type="button"
          className="c-button c-button--cancel c-modal__button"
          onClick={() => props.closeModal()}
        >
          <span className="c-button__text">Cancel</span>
        </button>
        </>
      }
    </Modal>
  );
};

export default ModalIA;
